module.exports = __webpack_public_path__ + "static/media/setaVermelha.ce16595a.svg";